import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import GuestNotStrict from './guest-not-strict';
import IsHostBookingExpired from './is-host-booking-expired';
import IsHostBookingPending from './is-host-booking-pending';
import IsGuestBookingPending from './is-guest-booking-pending';
import IsGuestBookingPaid from './is-guest-booking-paid';
import IsHostBookingPaid from './is-host-booking-paid';

const Content = (props) => {
  const {
    booking,
    isBookingStrict,
    isHost,
    disableButtons,
    offerChanged,
    payinLocked,
    onClearOfferChanged,
    onCancel,
    onAccept,
    url,
  } = props;

  const { status } = booking;

  if (!isBookingStrict && !isHost && status === 'PENDING') {
    return <GuestNotStrict url={url} />;
  }

  if (status === 'EXPIRED' && isHost) {
    return <IsHostBookingExpired booking={booking} />;
  }

  if (status === 'PENDING' && isHost) {
    return (
      <IsHostBookingPending
        booking={booking}
        disableButtons={disableButtons}
        offerChanged={offerChanged}
        payinLocked={payinLocked}
        isHost={isHost}
        onCancel={onCancel}
      />
    );
  }

  if (status === 'PENDING' && !isHost) {
    return (
      <IsGuestBookingPending
        booking={booking}
        disableButtons={disableButtons}
        offerChanged={offerChanged}
        payinLocked={payinLocked}
        onClearOfferChanged={onClearOfferChanged}
        onAccept={onAccept}
      />
    );
  }

  if (status === 'PAID') {
    if (isHost) {
      return <IsHostBookingPaid booking={booking} disableButtons={disableButtons} />;
    }

    return (
      <IsGuestBookingPaid
        disableButtons={disableButtons}
        onAccept={onAccept}
        onCancel={onCancel}
        isHost={isHost}
        booking={booking}
      />
    );
  }

  return null;
};

Content.propTypes = {
  booking: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  isBookingStrict: PropTypes.bool,
  isHost: PropTypes.bool.isRequired,
  disableButtons: PropTypes.bool.isRequired,
  offerChanged: PropTypes.bool,
  payinLocked: PropTypes.bool,
  onClearOfferChanged: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
};

const ActionFooter = (props) => {
  const content = Content(props);

  if (!content) {
    return null;
  }

  return (
    <Box p={2} mb={5} displayPrint="none">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {content}
        </Grid>
      </Grid>
    </Box>
  );
};

ActionFooter.propTypes = {
  booking: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  isBookingStrict: PropTypes.bool, // eslint-disable-line
  isHost: PropTypes.bool.isRequired, // eslint-disable-line
  disableButtons: PropTypes.bool.isRequired, // eslint-disable-line
  offerChanged: PropTypes.bool, // eslint-disable-line
  payinLocked: PropTypes.bool, // eslint-disable-line
  onClearOfferChanged: PropTypes.func, // eslint-disable-line
  onCancel: PropTypes.func.isRequired, // eslint-disable-line
  onAccept: PropTypes.func.isRequired, // eslint-disable-line
  url: PropTypes.string.isRequired, // eslint-disable-line
};

export default ActionFooter;
